// IE11 がPromiseに対応していないための考慮
import { Promise } from "es6-promise";
import { error } from "jquery";
import { response, retailerConfig } from "../entity/index";
import { constDialogMessage } from "./const";
import { dialogUtil } from "./dialog";
import { Logger } from "./logger";

export module ajax {

    export let returnTop: string;

    const errorPage:string = "Error";

    /**
     * 非同期通信(POST)
     * @param url
     * @param data (JSON.stringfyしたobject)
     */
    export function post(url: string, data: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const option = {
                            url: url,
                            data: data,
                            type: 'POST',
                            contentType: 'application/JSON',
                            dataType: 'json',
                            scriptCharset: 'utf-8',
                            timeout: 180000,
                        };

            $.ajax(option).done((data: response.responseEntity, textStatus: string, jqXHR: JQueryXHR) => {
                // 通信正常終了の場合
                if (data.result.code === 0) {
                    // WebAPI側の処理が正常終了の場合
                    resolve(data.data);
                }
                else if (data.result.code === -200) {
                    TransErrorPage();
                }
                else {
                    // 上記以外の場合
                    Logger.warn(jqXHR.responseText);
                    Logger.warn(textStatus);
                    reject();
                }
            }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                // 通信異常終了の場合
                Logger.error(jqXHR.responseText);
                Logger.error(textStatus);
                Logger.error(errorThrown);
                reject();
            });
        })
    }

    /**
     * 非同期通信(POST form)(主にCC連携)
     * @param url
     * @param data (JSON.stringfyしたobject)
     */
    export function postform(url: string, data: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const option = {
                url: url,
                data: "UID=" + data,
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                timeout: 180000,
                xhrFields: {
                    withCredentials: true
                }
            };

            $.ajax(option).done(() => {
                    resolve();
            }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                // 通信異常終了の場合
                Logger.error(jqXHR.responseText);
                Logger.error(textStatus);
                Logger.error(errorThrown);
                reject();
            });
        })
    }

    /**
     * 非同期通信(GET)(主にCC連携)
     * @param url
     */
    export function get(url: string, data: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const option = {
                xhrFields: { withCredentials: true },
                url: url,
                data: data,
                type: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                dataType: 'json',
                scriptCharset: 'utf-8',
                timeout: 180000,
            };

            $.ajax(option).done((data) => {
                resolve(data);
            }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                // 通信異常終了の場合
                Logger.error(jqXHR.responseText);
                Logger.error(textStatus);
                Logger.error(errorThrown);
                reject();
            });
        })
    }

    /**
     * 非同期通信(GET)(CCログインチェック用。)
     * @param url
     */
    export function getForCCLoginCheck(url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const option = {
                xhrFields: { withCredentials: true },
                url: url,
                type: 'GET',
                contentType: 'text/plain',
                dataType: 'text',
                scriptCharset: 'utf-8',
                timeout: 180000,
            };

            $.ajax(option).done((data, text, jqXHR) => {

                resolve(data);

            }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {

                if (jqXHR.status == 401) {
                    resolve(false)
                }

                // 通信異常終了の場合
                Logger.error(jqXHR.responseText);
                Logger.error(textStatus);
                Logger.error(errorThrown);
                reject();
            });


        })
    }

    /**
     * 非同期通信(POST)(CC /Sessions実行用)
     * @param url
     */
    export function postForCCSessions(url: string, data: string, jwt: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const option = {
                xhrFields: { withCredentials: true },
                headers: { "Authorization": jwt },
                url: url,
                data: data,
                type: 'POST',
                contentType: 'application/JSON',
                dataType: 'json',
                scriptCharset: 'utf-8',
                timeout: 180000,
            };

            $.ajax(option).done((data, textStatus, jqXHR) => {
                if (jqXHR.status == 204) {
                    // OKであれば204が返る。
                    resolve();
                } else {
                    reject();
                }

            }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                // 通信異常終了の場合
                Logger.error(jqXHR.responseText);
                Logger.error(textStatus);
                Logger.error(errorThrown);
                reject();
            });
        })
    }

    /**
     * バイナリを取得する(POST版)
     * @param url
     * @param data (JSON.stringfyしたobject)
     */
    export function postforblob(url: string, data: string,method:string): Promise<any> {
        return new Promise((resolve, reject) => {

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    resolve(this.response);
                } else if (this.readyState == 4 && this.status == 500) {
                    reject();
				}
            }

            // エラー
            xhr.onerror = function (e) {
                Logger.error(e);
                reject();
			}

            xhr.open(method, url);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.responseType = 'blob';
            xhr.send(data);
            
        })
    }

    /**
     * バイナリを取得する(GET版)
     * @param url
     * @param param (クエリストリング)
     */
    export function postforblob_get(url: string, param: string): Promise<any> {
        return new Promise((resolve, reject) => {

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    resolve(this.response);
                } else if (this.readyState == 4 && this.status == 500) {
                    reject();
                } else if (this.readyState == 4 && this.status == 400) {
                    TransErrorPage();
                    reject();
				}
            }

            // エラー
            xhr.onerror = function (e) {
                Logger.error(e);
                reject();
            }

            xhr.open('get', url + "?" + param);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.responseType = 'blob';
            xhr.send();

        })
    }

    /**
     * 続行不能となった場合はエラーページに遷移させる。
     * */
    export function TransErrorPage(): void {
        // セッションタイムアウト用の文言はid=1
        window.location.href = errorPage + "?id=1";
	}
}